<template>
  <div class="border">
    <div class="container navigation">
      <router-link to="/">
        <img
          class="navigation__logo"
          :src="require('@/assets/dver-logo.svg')"
        />
      </router-link>
      <div class="right">
        <nav class="menu" aria-label="navigation">
          <div
            class="menu__main"
            v-if="item.path !== '/my/info' && (item.auth ? isAuth : true)"
            v-for="item in list"
            :key="item.path"
            @mouseleave="changeSubList()"
            @mouseenter="changeSubList(item.children)"
          >
            <div class="menu__item-container">
              <div class="menu__item">
                <div>
                  <router-link
                    :to="item.path"
                    :class="{ active: item.path === $route.path }"
                  >
                    {{ item.title }}
                  </router-link>
                </div>
              </div>
              <div class="menu__sub" v-if="sublist.length > 0">
                <div v-for="(subMenu, idx) in sublist" :key="idx">
                  <router-link
                    class="menu__sub--title"
                    :to="subMenu.path"
                    v-if="
                      subMenu.userType === 'all'
                        ? true
                        : subMenu.userType === userType
                    "
                  >
                    {{ subMenu.name }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <hr />
        <div class="action">
          <div v-show="!isAuth" class="action__info">
            <router-link class="btn" to="/users/signin">로그인</router-link>
            <router-link class="btn" to="/join/intro">회원가입</router-link>
          </div>
          <div v-show="isAuth" class="action__info">
            <router-link class="btn" to="/my/info">마이페이지</router-link>
            <div class="btn" @click="signout()">로그아웃</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sublist: []
    };
  },
  props: ["list", "isAuth", "userType", "signout"],

  methods: {
    changeSubList(list) {
      if (!list) return (this.sublist = []);
      this.sublist = list;
    }
  }
};
</script>

<style scoped>
.border {
  padding: 0px 32px;
}
.right {
  display: flex;
  align-items: center;
  gap: 32px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--gray-700);
}
.container {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.navigation__logo {
  width: 72px;
  height: 28px;
}

hr {
  transform: rotate(-90deg);
  width: 16px;
  border: 0.5px solid var(--gray-400);
}

.menu {
  display: flex;
  align-items: center;
  gap: 48px;
}

.active {
  color: var(--primary-400);
  font-weight: 400;
}

.menu__item-container {
  position: relative;
}

.menu__sub {
  padding: 12px 8px;
  background-color: var(--white);
  border: 1px solid var(--gray-200);
  box-shadow: 0px 8px 16px -4px rgba(63, 83, 107, 0.08);
  border-radius: 12px;
  width: max-content;
  position: absolute;
  display: none;
  flex-direction: column;
  left: 50%;
  transform: translateX(-50%);
  top: 36px;
}

.menu__item {
  padding: 6px 0;
  box-sizing: border-box;
  cursor: pointer;
}
.menu__item-container:hover {
  color: var(--primary-400);
  font-weight: 400;
}

.menu__item:hover + .menu__sub {
  display: flex;
}
.menu__item + .menu__sub:hover {
  display: flex;
}

.menu__sub--title {
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--gray-700);
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 120px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
}

.menu__sub--title:hover {
  background-color: var(--gray-100);
  font-weight: 400;
}

.action__info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.action__btn {
  height: 40px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action__btn--login {
  width: 80px;
}

.action__btn--my {
  width: 96px;
}

.btn {
  cursor: pointer;
}
</style>
